import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import LazyRoute from '../LazyRoute';

// LazyRoute renders react-router-dom's Outlet component

const ProtectedRoute = () => {
  const { isLoggedIn } = useAuth();

  return isLoggedIn ? <LazyRoute /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
